import { Button, Skeleton, Tag } from "antd";
import { useState } from "react";
import { ReactComponent as DelIcon } from "../../../assets/Icons/DelIcon.svg";
import ReusableTable from "../../../Reuseable/ReusableTable/ReusableTable";
import "./ProductComp.scss";
import DeleteUserModal from "../UserComp/DeleteUserModal";
import moment from "moment";

const ProductTable = ({ data, loading, setParam,param}) => {
  const [isDeleteModalOpen, setIsDeleteModalOpen] = useState(false);
  const [userToDelete, setUserToDelete] = useState(null);



  const handleDeleteClick = (record) => {
    setUserToDelete(record);
    setIsDeleteModalOpen(true);
  };

  const handleConfirmDelete = () => {
    setIsDeleteModalOpen(false);
  };

  const columns = [
    {
      title: "#",
      dataIndex: "id",
      key: "id",
      width: 50,
      render: (id) =>
        loading ? (
          <Skeleton.Input size="small" active />
        ) : id !== undefined && id !== null ? (
          id
        ) : (
          "-"
        ),
    },
    {
      title: "Product Name",
      dataIndex: "short_name",
      key: "short_name",
      render: (short_name) =>
        loading ? <Skeleton.Input size="small" active /> : short_name || "-",
    },
    {
      title: "Product Key",
      dataIndex: "products",
      key: "products",
      render: (products) =>
        loading ? <Skeleton.Input size="small" active /> : products || "-",
    },
    {
      title: "Created On",
      dataIndex: "date",
      key: "date",
      render: (date) =>
        loading ? (
          <Skeleton.Input size="small" active />
        ) : date ? (
          moment(date).format("MMM D, YYYY – h:mm A")
        ) : (
          "-"
        ),
    },
    // {
    //   title: "Status",
    //   dataIndex: "status",
    //   key: "status",
    //   render: (status) =>
    //     loading ? (
    //       <Skeleton.Input size="small" active />
    //     ) : (
    //       <Tag
    //         className={`statusIndicator ${
    //           status === "Active" ? "activeStatus" : "inactiveStatus"
    //         }`}
    //         color={status === "Active" ? "green" : "red"}
    //       >
    //         {status || "N/A"}
    //       </Tag>
    //     ),
    // },
    {
      title: "Actions",
      dataIndex: "actions",
      key: "actions",
      render: (_, record) =>
        loading ? (
          <Skeleton.Input size="small" active />
        ) : (
          <Button
            type="text"
            icon={<DelIcon />}
            onClick={() => handleDeleteClick(record)}
          />
        ),
    },
  ];

  return (
    <div className="productTableContainer">
      <ReusableTable
        columns={columns}
        dataSource={loading ? Array(5).fill(0) : data?.results}
        rowKey="key"
        bordered
        pageSize={param?.page_size}
        CurrentPageNo={param?.page}
        totalItems={data?.count}
        triggerChange={(page, page_size) => {
          setParam({
            page, page_size
          })
        }}
      />
      <DeleteUserModal
        open={isDeleteModalOpen}
        onClose={() => setIsDeleteModalOpen(false)}
        onDelete={handleConfirmDelete}
      />
    </div>
  );
};

export default ProductTable;
